import { searchBox } from "instantsearch.js/es/widgets";

export default function (el, Alpine) {
    Alpine.bind(el, {
        'x-init'() {
            this.$data.__search.addWidgets([
                searchBox({
                    container: el,
                    showSubmit: false,
                    showReset: false,
                    showLoadingIndicator: true,
                    placeholder: 'Type to Search',
                    autofocus: true,
                    cssClasses: {
                        form: 'search__form',
                        input: 'instantsearch-searchBox',
                    },
                    templates: {
                        submit({cssClasses}, { html }) {
                            return html`<span class="${ cssClasses.submitIcon }">Search</span>`;
                        },
                    },
                })
            ]);
        }
    })
}